import { Doctor } from '@/store/doctor/types'

export interface ConsultoryState {
  loadingConsultoriesList: boolean
  loadingCreateConsultory: boolean
  loadingConsultoryModules: boolean
  consultoriesList: Array<ConsultoryItem>
  modules: ModulesResponse
  loadingDoctors: boolean
  doctors: Array<ModuleDoctorItem>
  doctorSearch: Doctor | null
  loadingSerachDoctor: boolean
  moduleSchedule: Array<ModuleScheduleItem>
  loadingModuleSchedule: boolean
  loadingScheduleDay: LoadingScheduleDay
  moduleEvents: Array<EventItem>
  loadingEvents: boolean
}

// INTERFACES FOR CONSULTORIES

export interface DoctorConsultoryRequest {
  name: string
  street: string
  externalNumber: string
  internalNumber: string
  internalFloor: string
  suburb: string
  municipality: string
  state: string
  postalCode: string
  phoneNumber: string
  phoneNumberExtension: string
  moduleCount: number
}

export interface ConsultoryCreatePayload<T> {
  entityId: number
  payload?: T
}

export interface ConsultoryItem extends DoctorConsultoryRequest {
  id: number
  lumineStatus: State
  lumineCredential: string
  lumineStatusDescription: string
}

export enum State {
  PendingToApprove = 1,
  Approving = 2,
  Approved = 3,
  Refused = 4,
  OutOfSystem = 5,
  SpecialChecking = 6
}

// INTERFACES FOR CONSULTORY MODULES

export interface ModuleItem {
  id: number
  name: string
  doctorsCount: number
  permissions: Array<Permission>
}

export interface Permission {
  enabled: boolean
  permissionName: ModulePermission
}

export enum ModulePermission {
  SCHEDULE = 'ConfigureSchedules',
  APPOINTMENTS = 'ConfigureAppointments',
  DOCTORS = 'ConfigureDoctors'
}

export interface ModulesResponse {
  consultoryId: number
  consultoryName: number
  modules: Array<ModuleItem>
}

export interface ModuleRequest {
  doctorId: number
  consultoryId: number
}

// INTERFACES FOR DOCTORS IN MODULE

export interface ModuleDoctorItem {
  firstSurname: string
  secondSurname: string
  lumineCredential: string
  name: string
  imageProfileUrl: string
}

export interface AddDoctorRequest {
  doctorId: number
  moduleId: number
}

// INTERFACES FOR MODULE SCHEDULE

export interface ModuleScheduleItem {
  isEnabled: boolean
  order: number
  dayOfWeek: number
  dayName: string
  startDateHour: number
  startDateMinute: number
  endDateHour: number
  endDateMinute: number
  startDate: string
  endDate: string
}

export interface ModuleScheduleTime {
  day: string
  morningHours: string
  eveningHours: string
  isEnabled: boolean
}

export interface DayObject {
  id: number
  name: string
  schedule: Array<ModuleScheduleItem>
}

export interface DayEnabled {
  day: number
  enabled: boolean
}

export interface DayTime {
  day: number
  hour: number
  minute: number
  order: number
  type: number
}

export interface DayScheduleRequest {
  isEnabled: boolean
  order: number
  dayOfWeek: number
  startDateHour: number | null
  startDateMinute: number | null
  endDateHour: number | null
  endDateMinute: number | null
}

export interface DayScheduleRequestCreate {
  moduleId: number
  request: DayScheduleRequest
}

export interface LoadingScheduleDay {
  dayNumber: number
  loading: boolean
}

export interface EnableDayRequest {
  moduleId: number
  weekDay: number
  dayNumber: number
  enabled: boolean
}

// EVENTS INTERFACES

export interface EventRequest {
  moduleId: number
  year: number
  weekNumber: number
}

export interface EventItem {
  id: number
  scheduleEventStatus: EventStatus
  eventStatus: string
  dayOfWeek: number
  dayName: string
  weekOfYear: number
  dayOfYear: number
  year: number
  startDate: string
  endDate: string
  startDateHour: number
  startDateMinute: number
  endDateHour: number
  endDateMinute: number
  doctorName: string
  notes: string
  doctorId: number
  patientId: number
  consultoryModuleId: number
}

export enum EventStatus {
  CREATED = 1,
  ASSIGNED = 2,
  CANCELED = 3,
  AGENDED = 4,
  CONSULTING = 5,
  ENDED = 6,
  FREE = 7,
  ACCEPTED = 81,
  REFUSED = 91,
  CANCELED_DOCTOR = 98,
  CANCELED_CONSULTORY = 99
}

export interface SuscribeEventRequest {
  moduleId: number
  scheduleEventId: number
  doctorId: number
  year: number
  weekNumber: number
}

export interface UnsuscribeEventRequest extends SuscribeEventRequest {
  type: number
}

export interface DoctorModuleItem {
  lumineCredential: string
  consultoryId: number
  consultoryName: string
  moduleId: number
  moduleName: string
  moduleNumber: string
}

export interface PendingConsultationItem {
  id: number
  scheduleEventStatus: EventStatus
  eventStatus: string
  dayOfWeek: number
  dayName: string
  weekOfYear: number
  dayOfYear: number
  year: number
  startDate: string
  endDate: string
  startDateHour: number
  startDateMinute: number
  endDateHour: number
  endDateMinute: number
  notes: string
  doctorId: number
  patientId: number
  patientName: string
  inObservation: boolean
  consultoryId: number
  consultoryName: string
  consultoryModuleId: number
  consultoryModuleName: string
  reserveDate: string
  patientImageProfileUrl: string
}

export interface ModuleConsultationRequest {
  doctorId: number
  moduleId: number
  year: number | null
  filterBy: string | null
  filterParam: number
}

export interface AnswerConsultationRequest {
  reasonId?: number
  eventId: number
  doctorId?: number
}
